// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Flash_Edit_Form$DvmAdminFrontendFr from "./Flash_Edit_Form.bs.js";
import * as Flash_Edit_Types$DvmAdminFrontendFr from "./Flash_Edit_Types.bs.js";
import * as Flash_Edit_Utils$DvmAdminFrontendFr from "./Flash_Edit_Utils.bs.js";
import * as Flash_Edit_Form_VO$DvmAdminFrontendFr from "./Flash_Edit_Form_VO.bs.js";
import * as Flash_Edit_NonFleet_Types$DvmAdminFrontendFr from "./steps/NonFleet/Flash_Edit_NonFleet_Types.bs.js";
import * as Flash_Edit_Form_Additional$DvmAdminFrontendFr from "./Flash_Edit_Form_Additional.bs.js";
import * as Flash_Edit_NonFleet_New_Vehicle_Form$DvmAdminFrontendFr from "./Flash_Edit_NonFleet_New_Vehicle_Form.bs.js";

function setForm(flash) {
  var match = Belt_Option.mapWithDefault(flash.orderTypes, undefined, (function (x) {
          return Belt_List.get(x, 0);
        }));
  var match$1 = flash.actionType;
  return {
          actionID: flash.actionId,
          actionLabel: flash.actionLabel,
          actionType: match !== undefined && match$1 !== undefined ? Flash_Edit_Types$DvmAdminFrontendFr.ActionTypeEdit.fromString(match$1, match) : Flash_Edit_Form$DvmAdminFrontendFr.initialState.actionType,
          budgetType: Belt_Option.getWithDefault(flash.budgetType, Flash_Edit_Form$DvmAdminFrontendFr.initialState.budgetType),
          orderType: Belt_Option.getWithDefault(flash.orderTypes, Flash_Edit_Form$DvmAdminFrontendFr.initialState.orderType),
          orderGroup: Belt_Option.mapWithDefault(flash.orderTypes, Flash_Edit_Form$DvmAdminFrontendFr.initialState.orderGroup, Flash_Edit_Utils$DvmAdminFrontendFr.orderListToGroup),
          stocDateStart: flash.stocDateStart,
          stocDateEnd: flash.stocDateEnd,
          stocDateType: Belt_Option.getWithDefault(flash.stocDateType, Flash_Edit_Form$DvmAdminFrontendFr.initialState.stocDateType),
          value: Belt_Option.mapWithDefault(flash.amount, Flash_Edit_Form$DvmAdminFrontendFr.initialState.value, (function (x) {
                  return Belt_Option.mapWithDefault(x.value, Flash_Edit_Form$DvmAdminFrontendFr.initialState.value, (function (x) {
                                return String(x);
                              }));
                })),
          numberType: Belt_Option.mapWithDefault(flash.amount, Flash_Edit_Form$DvmAdminFrontendFr.initialState.numberType, (function (x) {
                  return x.numberType;
                })),
          perfType: Belt_Option.getWithDefault(flash.perfType, Flash_Edit_Form$DvmAdminFrontendFr.initialState.perfType),
          includeFinancialCode: Belt_List.length(Belt_Option.getWithDefault(flash.financialCodes, /* [] */0)) > 0 || Belt_Option.getWithDefault(flash.financialCodeOrientation, /* NOTSET */2) !== /* NOTSET */2,
          financialCodes: Belt_Option.getWithDefault(flash.financialCodes, /* [] */0),
          financialCodeOrientation: Belt_Option.getWithDefault(flash.financialCodeOrientation, /* NOTSET */2),
          entryParcDatePeriodStart: flash.entryParcDatePeriodStart,
          entryParcDatePeriodEnd: flash.entryParcDatePeriodEnd,
          exitParcDatePeriodStart: flash.exitParcDatePeriodStart,
          exitParcDatePeriodEnd: flash.exitParcDatePeriodEnd,
          detentionMin: Belt_Option.mapWithDefault(flash.detentionMin, "", (function (prim) {
                  return String(prim);
                })),
          detentionMax: Belt_Option.mapWithDefault(flash.detentionMax, "", (function (prim) {
                  return String(prim);
                })),
          priceType: Belt_Option.getWithDefault(flash.priceType, ""),
          isPARCExit: Belt_Option.mapWithDefault(flash.orderTypes, flash.isPARCExit, (function (orderTypes) {
                  return Belt_Option.mapWithDefault(Belt_List.get(orderTypes, 0), flash.isPARCExit, (function (orderType) {
                                if (orderType > 12 || orderType < 1) {
                                  return flash.isPARCExit;
                                } else {
                                  return Belt_Option.getWithDefault(flash.isPARCExit, false);
                                }
                              }));
                })),
          requestType: Belt_Option.getWithDefault(flash.requestType, "")
        };
}

function setFormAdditional(flash) {
  return {
          clientType: Belt_Option.mapWithDefault(flash.clientTypes, "", (function (x) {
                  return Belt_Option.getWithDefault(Belt_List.head(x), "");
                })),
          saleType: Belt_Option.getWithDefault(flash.saleTypes, /* [] */0),
          dealerIds: Belt_Option.mapWithDefault(flash.dealerWithAgents, Belt_Option.mapWithDefault(flash.dealerIds, Flash_Edit_Form_Additional$DvmAdminFrontendFr.initialState.dealerIds, (function (list) {
                      return Belt_List.map(list, (function (x) {
                                    return {
                                            label: {
                                              TAG: /* String */3,
                                              _0: x
                                            },
                                            value: x
                                          };
                                  }));
                    })), (function (dealersWithAgents) {
                  if (Belt_List.length(dealersWithAgents) > 0) {
                    return Belt_List.map(dealersWithAgents, (function (x) {
                                  return {
                                          label: {
                                            TAG: /* String */3,
                                            _0: x.parent
                                          },
                                          value: x.parent
                                        };
                                }));
                  } else {
                    return Belt_Option.mapWithDefault(flash.dealerIds, Flash_Edit_Form_Additional$DvmAdminFrontendFr.initialState.dealerIds, (function (list) {
                                  return Belt_List.map(list, (function (x) {
                                                return {
                                                        label: {
                                                          TAG: /* String */3,
                                                          _0: x
                                                        },
                                                        value: x
                                                      };
                                              }));
                                }));
                  }
                })),
          dealerWithAgents: Belt_Option.mapWithDefault(flash.dealerWithAgents, Flash_Edit_Form_Additional$DvmAdminFrontendFr.initialState.dealerWithAgents, (function (list) {
                  return Belt_List.concatMany(Belt_List.toArray(Belt_List.map(list, (function (x) {
                                        return Belt_List.map(x.child, (function (child) {
                                                      return {
                                                              label: {
                                                                TAG: /* String */3,
                                                                _0: x.parent + " - " + child
                                                              },
                                                              value: x.parent + ":::" + child
                                                            };
                                                    }));
                                      }))));
                })),
          attributionVehicleDateStart: flash.attributionVehicleDateStart,
          attributionVehicleDateEnd: flash.attributionVehicleDateEnd
        };
}

function setVOForm(flash) {
  return {
          carAge: Belt_Option.getWithDefault(flash.carAgeAtOrderDate, 0) > Belt_Option.getWithDefault(flash.carAgeAtDeliveryDate, 0) ? Belt_Option.mapWithDefault(flash.carAgeAtOrderDate, Flash_Edit_Form_VO$DvmAdminFrontendFr.initialState.carAge, (function (prim) {
                    return String(prim);
                  })) : Belt_Option.mapWithDefault(flash.carAgeAtDeliveryDate, Flash_Edit_Form_VO$DvmAdminFrontendFr.initialState.carAge, (function (prim) {
                    return String(prim);
                  })),
          carAgeWhich: Belt_Option.getWithDefault(flash.carAgeAtOrderDate, 0) === 0 && Belt_Option.getWithDefault(flash.carAgeAtDeliveryDate, 0) === 0 ? "none" : (
              Belt_Option.getWithDefault(flash.carAgeAtOrderDate, 0) > Belt_Option.getWithDefault(flash.carAgeAtDeliveryDate, 0) ? "order" : "delivery"
            ),
          possesionPeriod: Belt_Option.getWithDefault(flash.possesionPeriodAtOrderDate, 0) > Belt_Option.getWithDefault(flash.possesionPeriodAtDeliveryDate, 0) ? Belt_Option.mapWithDefault(flash.possesionPeriodAtOrderDate, Flash_Edit_Form_VO$DvmAdminFrontendFr.initialState.possesionPeriod, (function (prim) {
                    return String(prim);
                  })) : Belt_Option.mapWithDefault(flash.possesionPeriodAtDeliveryDate, Flash_Edit_Form_VO$DvmAdminFrontendFr.initialState.possesionPeriod, (function (prim) {
                    return String(prim);
                  })),
          possesionPeriodWhich: Belt_Option.getWithDefault(flash.possesionPeriodAtOrderDate, 0) === 0 && Belt_Option.getWithDefault(flash.possesionPeriodAtDeliveryDate, 0) === 0 ? "none" : (
              Belt_Option.getWithDefault(flash.possesionPeriodAtOrderDate, 0) > Belt_Option.getWithDefault(flash.possesionPeriodAtDeliveryDate, 0) ? "order" : "delivery"
            ),
          brands: Belt_Option.mapWithDefault(flash.brands, Flash_Edit_Form_VO$DvmAdminFrontendFr.initialState.brands, (function (x) {
                  return Belt_Option.getWithDefault(x.brands, Flash_Edit_Form_VO$DvmAdminFrontendFr.initialState.brands);
                })),
          ie: Belt_Option.mapWithDefault(flash.brands, /* ALL */0, (function (x) {
                  return Belt_Option.getWithDefault(x.ie, /* ALL */0);
                })),
          actionWithVO: Flash_Edit_Utils$DvmAdminFrontendFr.actionHasVO(flash),
          usedCarModels: Belt_Option.getWithDefault(flash.usedCarModels, /* [] */0)
        };
}

function setFormGeneralDates(flash) {
  return {
          startDate: flash.orderStartDate,
          endDate: flash.orderEndDate,
          deliveryStartDate: flash.deliveryStartDate,
          deliveryEndDate: flash.deliveryEndDate,
          registrationStartDate: flash.registrationStartDate,
          registrationEndDate: flash.registrationEndDate
        };
}

function setNonFleetNewVehicleForm(flash, newVehicle) {
  return {
          models: Belt_Option.mapWithDefault(newVehicle.modelPhases, /* [] */0, (function (x) {
                  return Belt_List.map(x, (function (model) {
                                return model.one;
                              }));
                })),
          modelPhases: Belt_Option.mapWithDefault(newVehicle.modelPhases, /* [] */0, (function (x) {
                  return Belt_List.map(x, (function (model) {
                                return model.one + Flash_Edit_NonFleet_Types$DvmAdminFrontendFr.delimiter + model.two;
                              }));
                })),
          mappingDirection: Belt_Option.getWithDefault(newVehicle.mappingDirection, Flash_Edit_NonFleet_New_Vehicle_Form$DvmAdminFrontendFr.initialState.mappingDirection),
          engineTypes: Belt_Option.getWithDefault(newVehicle.engineTypes, Flash_Edit_NonFleet_New_Vehicle_Form$DvmAdminFrontendFr.initialState.engineTypes),
          versions: Belt_List.map(Belt_Option.getWithDefault(newVehicle.modelVersions, /* [] */0), (function (x) {
                  return {
                          label: {
                            TAG: /* String */3,
                            _0: x
                          },
                          value: x
                        };
                })),
          brandsNewCar: Belt_Option.getWithDefault(newVehicle.brandsNewCar, Flash_Edit_NonFleet_New_Vehicle_Form$DvmAdminFrontendFr.initialState.brandsNewCar),
          vehicleType: Belt_Option.getWithDefault(flash.vehicleType, /* NOTSET */3),
          includeAllModels: Belt_Option.mapWithDefault(newVehicle.modelPhases, true, (function (x) {
                  return Belt_List.length(x) === 0;
                }))
        };
}

export {
  setForm ,
  setFormAdditional ,
  setVOForm ,
  setFormGeneralDates ,
  setNonFleetNewVehicleForm ,
}
/* Flash_Edit_Form-DvmAdminFrontendFr Not a pure module */
